import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { VdoSessionState } from '@pcp/auth';

export const VOTING_ELEMENT_BASE_URL = new InjectionToken<string>(
    'VOTING_ELEMENT_BASE_URL'
);
export const DIFFICULT_QUESTION_ELEMENT_BASE_URL = new InjectionToken<string>(
    'DIFFICULT_QUESTION_ELEMENT_BASE_URL'
);
export const DIFFICULT_QUESTION_ELEMENT_LANGUAGE_CODE =
    new InjectionToken<string>('DIFFICULT_QUESTION_ELEMENT_LANGUAGE_CODE');
export const DIFFICULT_QUESTION_ELEMENT_ENET_TOKEN = new InjectionToken<
    Observable<string>
>('DIFFICULT_QUESTION_ELEMENT_ENET_TOKEN'); // string oder Observable<string> ?
export const DIFFICULT_QUESTION_ELEMENT_IS_MAIN_CLIENT = new InjectionToken<
    'true' | 'false'
>('DIFFICULT_QUESTION_ELEMENT_IS_MAIN_CLIENT');
export const DIFFICULT_QUESTION_ELEMENT_MUTE_AUDIO = new InjectionToken<
    'true' | 'false'
>('DIFFICULT_QUESTION_ELEMENT_MUTE_AUDIO');
export const ENVIRONMENT_TYPE = new InjectionToken<
    'PCP' | 'FahrTUTOR'
>('ENVIRONMENT_TYPE');

/** Simulator session for this app, or `null` where it has none. Bound in `provide-config.ts`. */
export const VDO_SESSION = new InjectionToken<
    Observable<VdoSessionState | null>
>('VDO_SESSION');
